import { IframelyMedia, InfiniteListMode } from '@prismamedia/one-components';
import {
  IndexRange,
  ItemSerialized,
  ItemToRenderProps,
  MEDIA_TYPES_LABEL,
  ViewMode,
} from 'components/MediaInput/MultimediaPlugin/types';
import { ReactNode } from 'react';

export interface ListViewProps<Item = ItemSerialized> {
  allowSearch?: boolean;
  className?: string;
  fetchMore?: (params?: IndexRange) => Promise<any>;
  fetchMoreMode?: InfiniteListMode;
  itemToRender: (
    item: Item,
    pluginType?: MEDIA_TYPES_LABEL,
  ) => ItemToRenderProps;
  items: Item[];
  suggestedItems?: Item[] | null;
  isBusy?: boolean;
  isDisabled: boolean;
  isLoading?: boolean;
  onItemClick: (
    item: Item,
    pluginType: MEDIA_TYPES_LABEL,
    cb?: (item: Item) => Promise<IframelyMedia>,
  ) => void;
  selectedItems: Item[];
  pluginType: MEDIA_TYPES_LABEL;
  value?: string;
  viewMode: ViewMode;
}

export interface ListItemCardProps {
  chip?: string | ReactNode;
  createdDate?: string | null;
  id: string;
  image?: string;
  isBusy?: boolean;
  isDisabled: boolean;
  isSelected: boolean;
  onItemClick: () => void;
  publicUrl?: string | null;
  publishDate?: string | null;
  site?: string;
  status?: string;
  text?: string;
  title?: string | null;
  viewMode?: ViewMode;
  isSuggestionItem?: boolean;
  slideShowArticleCount?: number;
}

export type MultimediaListProps<Item = any> = ListViewProps<Item>;
export type GridViewProps = MultimediaListProps;
export type GridItemCardProps = ListItemCardProps;

export enum MultiMediaListItemType {
  HEADING = 'HEADING',
  ARTICLE = 'ARTICLE',
}
